import * as React from "react";
import Component from "../../AbstractComponent";
import ContractSummary from "./ContractSummary";
import ContractDetailsReadonly from "./ContractDetailsReadonly";
import ContractDetailsEditable from "./ContractDetailsEditable";
import {
	Card
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class ContractCard extends Component {
	public state = {
		isSummaryView: true
	};

  constructor(public props) {
    super(props);

		let isSummaryView = true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		const isReadonly = this.props.contract?.isReadonly ||
											 this.props.isReadonly;

		if ((this.props.mainCardPresentation && isReadonly) || this.props.openedByDefault) {
			isSummaryView = false;
		}

		this.state.isSummaryView = isSummaryView;
	}

  
	public changeView = (): void => {
		if (typeof this.props.contractIdForDetailsPresentation !== "undefined") {
			if (this.props.contractIdForDetailsPresentation === this.props.contract?.id) {
				this.props.changeContractIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changeContractIdForDetailsPresentation.call(this, this.props.contract?.id);
			} 
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}
	
  public render() {
		const isReadonly = this.props.contract?.isReadonly ||
											 this.props.isReadonly;
		const isSummaryView = typeof this.props.contractIdForDetailsPresentation !== "undefined" ?
														this.props.contractIdForDetailsPresentation !== this.props.contract?.id :
														this.state.isSummaryView;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "100%",
						height: "60px",
						display: "flex",
						justifyContent: "flex-end",
						paddingRight: "7px"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					{
						isSummaryView && <ContractSummary {...this.props}/>
					}

					{
						!isSummaryView && (isReadonly || !this.props.mainCardPresentation) && <ContractDetailsReadonly {...this.props}/>
					}	

					{
						!isSummaryView && !isReadonly && this.props.mainCardPresentation && <ContractDetailsEditable {...this.props}/>
					}	
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
